enum BannerTypes {
  Image = 'image',
  Video = 'video',
  Text = 'text'
};

export default BannerTypes;